module.exports = __webpack_public_path__ + "img/pisces.f028cb68.png";